import { FC, useEffect, useState } from "react";
import { styled } from "styled-components";
import { Entry } from "contentful";
import { font } from "../lib/sharedStyles";
import useDataFromDom from '../hooks/useDataFromDom';

const Container = styled.div`
  background-color: #f9f9f9;
  padding: 30px 21px;

  p {
    font-family: 'Futura';
    text-align: center;
  }
`;

// Structured with unnecessary div like this to get around
// using !important to override the section level font-size
// declaration. Something to fix when there is time.
const Heading = styled.div`
  > p {
    ${font('Futura', 600, '16px', '20px', '0.1px')};
    color: #000;
    text-transform: uppercase;
    margin: 0 0 12px;
  }
`;

const Subheading = styled.div`
  > p {
    ${font('Futura', 600, '14px', '18px')};
    color: #111;
    margin: 0 0 20px;
  }
`;

const Code = styled.div`
  > p {
    ${font('Futura', 600, '24px', '1')}
    color: #666;
    background-color: #fff;
    margin: 0;
    padding: 12px;
    border-radius: 6px;
    border: 1px dashed #ccc;
  }
`;

const CopyButton = styled.button<{ $isCopiedState: boolean; }>`
  display: flex;
  align-items: center;
  border: none;
  background: none;
  padding: 0;
  margin: 16px auto 10px;
  ${font('SourceSansPro', 400, '12px', '19px', '0.1px')};

  svg {
    margin-right: 8px;
    vertical-align: middle;
  }

  span {
    color: #666;
    text-decoration-line: underline;

    ${({ $isCopiedState }) => $isCopiedState && `
      color: #0A9E2F;
    `}
  }
`;

interface Props extends Entry {
  fields: {
    heading?: string;
    subheading?: string;
    couponType: 'shop' | 'play';
  }
}

const CouponCode: FC<Props> = ({ fields: { heading, subheading, couponType }}) => {
  const [customerCode, setCustomerCode] = useState('');
  const [codeCopied, setCodeCopied] = useState(false);
  const { customer, customerShopCoupon, customerPlayCoupon, site, region }: any = useDataFromDom(['data-data'], 'debut-page-react-target');
  console.log('customer', customer);
  console.log('customerShopCoupon', customerShopCoupon);
  console.log('customerPlayCoupon', customerPlayCoupon);
  const environmentConfig = {
    active: {
      adminApiUrl: 'https://active-shopify-admin-api.fendergarage.com/admin-actions',
      adminApiKey: 'e7esizc42J3goul1VC4Fw7dxiXXPQZJkMiYjJoDh'
    },
    qa: {
      adminApiUrl: 'https://qa-shopify-admin-api.fendergarage.com/admin-actions',
      adminApiKey: 'XDeRBllJ99eOGKu5mbbF8UZf6rPyi8J7IRwLTtzj'
    },
    prod: {
      adminApiUrl: 'https://shopify-admin-api.fendergarage.com/admin-actions',
      adminApiKey: 'Fw7WN6Sh5h8X0Ot2y2msM5p8iJZA9pUI5f3atyxT'
    }
  };

  const shopSettings = (window as any).shopSettings || {};
  const { environment }: { environment: 'active' | 'qa' | 'prod' } = shopSettings;
  const { adminApiUrl = '', adminApiKey = '' } = environmentConfig[environment] || {};

  async function getCustomerShopCode() {
    let siteID = `${site}_${region}`;
    let requestData = {
      siteID: siteID.toUpperCase(),
      requestType: 'postDebut',
      data: {
        customerID: customer,
      }
    };
    await fetch(adminApiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': adminApiKey
      },
      body: JSON.stringify(requestData)
    })
      .then(response => response.json())
      .then(responseJSON => {
           console.log('getCustomerShopCodeResponse:', responseJSON);
           if(responseJSON.data && responseJSON.data.customerDebutCouponCode) {
            console.log('customerShopCoupon:', responseJSON.data.customerDebutCouponCode);
             setCustomerCode(responseJSON.data.customerDebutCouponCode);
           }
      })
      .catch(error => console.error('getCustomerShopCode error:', error));
  }

  async function getCustomerPlayCode() {
    let siteID = `${site}_${region}`;
    let requestData = {
      siteID: siteID.toUpperCase(),
      requestType: 'postPlayDebut',
      data: {
        customerID: customer,
      }
    };
    await fetch(adminApiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': adminApiKey
      },
      body: JSON.stringify(requestData)
    })
      .then(response => response.json())
      .then(responseJSON => {
           console.log('customerPlayCouponCodeResponse:', responseJSON);
           if(responseJSON.data && responseJSON.data.customerPlayCouponCode) {
            console.log('customerPlayCoupon:', responseJSON.data.customerPlayCouponCode);
             setCustomerCode(responseJSON.data.customerPlayCouponCode);
           }
      })
      .catch(error => console.error('getCustomerPlayCode error:', error));
  }

  const handleClick = () => {
    navigator.clipboard.writeText(customerCode).then(() => {
      setCodeCopied(true);
      setTimeout(() => {
        setCodeCopied(false);
      }, 3000);
    });
  }

  useEffect(() => {
    const fetchData = async () => {
      if(customer && customer.length) {
        if (couponType == 'shop' && (!customerCode || !customerCode.length)) {
          console.log('shop coupon');
          if(customerShopCoupon && customerShopCoupon.length) {
            console.log('customerShopCoupon EXISTS:', customerShopCoupon);
            setCustomerCode(customerShopCoupon);
          }
          else {
           console.log('customerShopCoupon API CALL: getCustomerShopCode');
           await getCustomerShopCode();
          }
        } else if (couponType == 'play' && (!customerCode || !customerCode.length)) {
          console.log('play coupon');
          if(customerPlayCoupon && customerPlayCoupon.length) {
            console.log('customerPlayCoupon EXISTS:', customerPlayCoupon);
            setCustomerCode(customerPlayCoupon);
          }
          else {
           console.log('customerPlayCoupon API CALL: getCustomerPlayCode');
           await getCustomerPlayCode();
          }
        }
      }
    };
    fetchData();
  }, [customer, couponType, customerCode, customerShopCoupon, customerPlayCoupon]);

  return (
    <Container data-coupon-code={customerCode}>
      {(heading) && <Heading><p>{heading}</p></Heading>}
      {(subheading) && <Subheading><p>{subheading}</p></Subheading>}
      {(customerCode) && <Code><p>{customerCode}</p></Code>}

      <CopyButton onClick={handleClick} $isCopiedState={codeCopied}>
        {(codeCopied) ? (
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none"><path fill="#0A9E2F" stroke="#0A9E2F" stroke-width=".714" d="M5.843 15.8 1 9.421l1.33-1.75 3.513 4.627L14.42 1l1.33 1.751L5.843 15.8Z"/></svg>
            promo code copied!
          </span>
        ) : (
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none"><path stroke="#595959" stroke-linecap="round" stroke-linejoin="round" stroke-opacity=".6" stroke-width="2" d="M6 6.34V4.159c0-.872 0-1.309.182-1.642.16-.293.414-.532.728-.68.356-.17.823-.17 1.757-.17h4.666c.934 0 1.4 0 1.757.169.313.15.569.388.728.68.182.334.182.77.182 1.643V8.52c0 .872 0 1.309-.182 1.642-.16.293-.415.532-.729.68-.356.17-.822.17-1.753.17H11M6 6.34H3.667c-.934 0-1.4 0-1.757.17-.314.15-.569.387-.728.68C1 7.524 1 7.96 1 8.833v4.362c0 .872 0 1.308.182 1.641.16.294.414.532.728.681.356.17.822.17 1.754.17h4.672c.932 0 1.398 0 1.754-.17.313-.149.569-.388.728-.68.182-.334.182-.77.182-1.64v-2.183M6 6.34h2.333c.934 0 1.4 0 1.757.17.313.15.569.387.728.68.182.333.182.77.182 1.64v2.184"/></svg>
            copy promo code
          </span>
        )}
      </CopyButton>
    </Container>
  );
}

export default CouponCode;